import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FileMailRequest } from './mail-upload.models';

@Injectable({
  providedIn: 'root'
})
export class MailUploadService {
  private readonly _http = inject(HttpClient);

  /** Files a mail into a dossier. The endpoint answers 200 with an empty body. */
  public fileMail(request: FileMailRequest): Promise<void> {
    return firstValueFrom(this._http.post<void>('/api/office/Mailablage/Neu', request));
  }
}
